import GenerateRegistrationLink from "./GenerateRegistrationLink";
export default GenerateRegistrationLink;
